import { Filters } from 'gql/autogen/Filters';
import { ReviewSortState } from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.types';
import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { SortMatrix } from 'gql/autogen/SortMatrix';
import { FilterMatrix } from 'gql/autogen/FilterMatrix';
import { selectActivityContentLocale, selectCurrentReviewFilter, selectCurrentReviewSort, selectReviewSortAndFilterMatrix } from 'component/page/detail/store/detail.selectors';
import { selectActivityIdFromBootstrap, selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { fetchReview, setCurrentReviewFilter, setCurrentReviewSort } from 'component/page/detail/store/review';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';

export interface SortFilterStateProps {
    cms: CmsValue;
    filterMatrix: FilterMatrix;
    sortMatrix: SortMatrix;
    currentFilter: Filters;
    currentSort: ReviewSortState;
    contentLocale: string;
    activityId: number;
    screenSize: ScreenSize;
}

interface DispatchProps {
    onSortChangeCreator: (activityId: number, currentFilters?: Filters) => (sort: ReviewSortState) => void;
    onFilterChangeCreator: (activityId: number, currentSort?: ReviewSortState) => (filter: Filters) => void;
}

export type SortFilterProps = SortFilterStateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectReviewSortAndFilterMatrix,
    selectActivityContentLocale,
    selectCurrentReviewSort,
    selectCurrentReviewFilter,
    selectActivityIdFromBootstrap,
    selectScreenSize,
    (cms, sortAndFilterMatrix, contentLocale, currentReviewSort, currentReviewFilter, activityId, screenSize: ScreenSize): SortFilterStateProps => {
        const reviewSortMatrix = sortAndFilterMatrix?.sort || {};
        const reviewFilterMatrix = sortAndFilterMatrix?.filter || {};

        return {
            cms,
            filterMatrix: reviewFilterMatrix,
            sortMatrix: reviewSortMatrix,
            currentFilter: currentReviewFilter,
            currentSort: currentReviewSort,
            contentLocale,
            activityId,
            screenSize,
        };
    },
);

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    onSortChangeCreator: (activityId: number, currentFilter?: Filters) => (sort: ReviewSortState) => {
        dispatch(setCurrentReviewSort(sort));
        fetchReview(
            activityId,
            sort && { sort: { code: sort.code, order: sort.order } },
            currentFilter && { filters: { valueFilters: currentFilter.valueFilters, rangeFilters: currentFilter.rangeFilters } },
        );
    },
    onFilterChangeCreator: (activityId: number, currentSort?: ReviewSortState) => (filter: Filters) => {
        dispatch(setCurrentReviewFilter(filter));
        fetchReview(
            activityId,
            currentSort && { sort: { code: currentSort.code, order: currentSort.order } },
            filter && { filters: { valueFilters: filter.valueFilters, rangeFilters: filter.rangeFilters } },
        );
    },
});
